import { Box, Skeleton, Text } from "@mantine/core";
import classes from "./flow-strip.module.css";

export type FlowCell = {
  label: string;
  value: string;
  hint?: string;
  muted?: boolean;
  total?: boolean;
};

type Props = {
  label: string;
  cells: FlowCell[];
  loading?: boolean;
};

/** Эхний + Нэхэмжилсэн − Төлсөн − Кредит нот = Эцсийн гэх мэт үлдэгдлийн хөдөлгөөний мөр. */
export function FlowStrip({ label, cells, loading }: Props) {
  return (
    <Box
      component="section"
      aria-label={label}
      className={classes.flow}
      // 6+ нүдтэй үед (цуцалсан/залруулга орсон) дүн таслагдахгүйн тулд нягт горим; сүүлийн «эцсийн» нүд өргөн.
      data-dense={cells.length > 5 || undefined}
      style={{ "--flow-cols": cells.length, "--flow-lead": cells.length - 1 } as React.CSSProperties}
    >
      {cells.map((f, i) => (
        <Box key={i} className={classes.flowCell} data-total={f.total || undefined}>
          <Text span className={classes.flowLabel}>
            {f.label}
          </Text>
          {loading ? (
            <Skeleton h={26} w="70%" />
          ) : (
            <Text span className={classes.flowValue} data-muted={f.muted || undefined} data-total={f.total || undefined}>
              {f.value}
            </Text>
          )}
          <Text span className={classes.flowHint}>
            {loading ? " " : (f.hint ?? " ")}
          </Text>
        </Box>
      ))}
    </Box>
  );
}
